import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DateTime } from 'luxon';

import commonDe from './locales/de/common.json';
import commonEn from './locales/en/common.json';
import commonRu from './locales/ru/common.json';
import commonFr from './locales/fr/common.json';
import commonIt from './locales/it/common.json';
import commonEs from './locales/es/common.json';
import commonHe from './locales/he/common.json';
import commonZh from './locales/zh/common.json';
import commonJa from './locales/ja/common.json';
import commonAr from './locales/ar/common.json';
import { luxonLocale } from './localeUi.js';
import { SUPPORTED_LNGS } from './supportedLngs.js';

const resources = {
  de: { common: commonDe },
  en: { common: commonEn },
  ru: { common: commonRu },
  fr: { common: commonFr },
  it: { common: commonIt },
  es: { common: commonEs },
  he: { common: commonHe },
  zh: { common: commonZh },
  ja: { common: commonJa },
  ar: { common: commonAr }
};

const detectionOptions = {
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'lng'
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    detection: detectionOptions,
    resources,
    ns: ['common'],
    defaultNS: 'common',
    supportedLngs: [...SUPPORTED_LNGS],
    interpolation: {
      escapeValue: false
    }
  })
  .then(() => {
    if (i18n.services.formatter && typeof i18n.services.formatter.add === 'function') {
      i18n.services.formatter.add('DATE_HUGE', (value, lng) => {
        return DateTime.fromJSDate(value).setLocale(luxonLocale(lng)).toLocaleString(DateTime.DATE_HUGE);
      });
    }
  });

export default i18n;
